import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Asset } from '@/types/asset_search';

const initialAssetSlice: Asset = {
  asset_uuid: '',
  zone_name: '',
  vehicle_make: '',
  vehicle_model: '',
  vehicle_year: 0,
  vehicle_stock_number: null,
  dtc: [],
  lat: 0,
  lon: 0,
};

const assetSlice = createSlice({
  name: 'asset',
  initialState: initialAssetSlice,
  reducers: {
    setAsset(state, action: PayloadAction<Asset>) {
      state.asset_uuid = action.payload.asset_uuid;
      state.zone_name = action.payload.zone_name;
      state.vehicle_make = action.payload.vehicle_make;
      state.vehicle_model = action.payload.vehicle_model;
      state.vehicle_year = action.payload.vehicle_year;
      state.vehicle_stock_number = action.payload.vehicle_stock_number;
      state.dtc = action.payload.dtc;
      state.lat = action.payload?.lat;
      state.lon = action.payload?.lon;
    },
  },
});

export const { setAsset } = assetSlice.actions;
export default assetSlice.reducer;
